<section *ngIf="isProjectModelsLoading && !isProjectModelsLoaded">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="isProjectModelsLoading"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="(!isProjectModelsLoading || isProjectModelsLoaded) && !isModalMode"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-spin [spinning]="!projectModelSelectOptions || !sourceModel">
    <rappider-crud-view-edit-form [config]="PROJECT_MODEL_RELATION_CREATE_CONFIG"
                                  [submitButtonLoading]="isSubmitButtonLoading"
                                  [data]="defaultProjectModelRelationData"
                                  (fieldValueChange)="onFieldValueChange($event)"
                                  (formSubmit)="onFormSubmit($event)"></rappider-crud-view-edit-form>
  </rappider-spin>
</section>
